import { Stack, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import CPTEyeTrackingPanel from "./CPTEyeTrackingPanel";
import CPTSectionHeader from "./CPTSectionHeader";
import type {
  ContinuousPerformanceStageEvent,
  DistanceData,
  HeadVelocity,
  PupilSizeData,
} from "types/tests";

interface CPTEyeTrackingSectionProps {
  headVelocityData?: HeadVelocity[];
  eyeDisplacements?: DistanceData[];
  pupilSizeData?: PupilSizeData[];
  stageEvents?: ContinuousPerformanceStageEvent[];
  sectionNumber?: number;
}

const CPTEyeTrackingSection: React.FC<CPTEyeTrackingSectionProps> = ({
  headVelocityData,
  eyeDisplacements,
  pupilSizeData,
  stageEvents,
  sectionNumber,
}) => {
  const { t } = useTranslation();
  const ns = "extraTests.continuousPerformance.result.eyeTracking";
  return (
    <Stack gap="md">
      <Stack gap={4}>
        <CPTSectionHeader number={sectionNumber} title={t(`${ns}.title`)} />
        <Text size="sm" c="dimmed">
          {t(`${ns}.description`)}
        </Text>
      </Stack>
      <CPTEyeTrackingPanel
        stageEvents={stageEvents}
        headVelocityData={headVelocityData}
        eyeDisplacements={eyeDisplacements}
        pupilSizeData={pupilSizeData}
      />
    </Stack>
  );
};

export default CPTEyeTrackingSection;
